export const convertToNumber = (str) => {
  return Number(str?.split(",")?.join(""));
};
